import React, { useEffect } from "react";
import HelmetLayout from "../components/HelmetLayout/HelmetLayout";

import "../components/Styles/CookieTermsPrivacy.css";

const Privacy = () => {
  useEffect(() => {
    (function (d, s, id) {
      var js,
        tjs = d.getElementsByTagName(s)[0];

      // if (d.getElementById(id)) return;

      js = d.createElement(s);
      js.id = id;

      js.src = "https://app.termly.io/embed-policy.min.js";

      tjs.parentNode.insertBefore(js, tjs);
    })(document, "script", "termly-jssdk");
  }, []);

  return (
    <div className="container">
      <HelmetLayout
        titleProps={`Privacy | Swifty Global`}
        children={
          <>
            <meta
              property="og:title"
              content="Privacy | Swifty Global"
              data-react-helmet="true"
            />
            <meta
              property="og:type"
              content="website"
              data-react-helmet="true"
            />
            <meta
              property="og:url"
              content="https://www.swifty.global/privacy"
              data-react-helmet="true"
            />
          </>
        }
      />

      <div className="center-container">
        <div
          name="termly-embed"
          data-id="e83e6456-2a0a-4141-926d-56e9b70dd263"
          data-type="iframe"
        ></div>
      </div>

      {/* <CookieComponent /> */}
    </div>
  );
};

export default Privacy;
